import { RootState } from "@/store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLocalTranslation } from "@/hooks/useLocalTranslation";
import { setSeries } from '@/store/slices/video/seriesSlice';
import { setVideo } from '@/store/slices/video/videoSlice';

import NavBar from "@/components/video/navBar";

import "./style.css"
import { allPaths } from "@/constants/urlPaths";
import { addCurrentThemeClassToEle } from "@/utils";
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";

export default function Search() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { common } = useLocalTranslation();
    const videoDetails = useSelector((state: RootState) => state.videoReducer.video);
    const seriesDetails = useSelector((state: RootState) => state.seriesReducer.series);
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);
    const searchQuery = searchParams.get("search_query");
    const [searchedVideos, setSearchedVideos] = useState<any>([])
    const { topSafeComponent } = useSafeAreaInsets();
    // useEffect(() => {
    //     console.log(videoDetails)
    // }, [videoDetails])

    useEffect(() => {
        handleSearchVideos()
    }, [searchQuery])


    const handleSearchVideos = () => {
        if (searchQuery) {
            const searchResults = searchVideosByTitle(searchQuery)
            setSearchedVideos(searchResults)
        } else {
            navigate(allPaths.dashboard);
        }
    }

    const searchVideosByTitle = (searchStr: string) => {
        const lowerSearch = searchStr.toLowerCase();

        return seriesDetails.flatMap((section, sectionIndex) =>
            section.videos
                .filter(video => video.title.toLowerCase().includes(lowerSearch))
                .map(video => ({
                    sectionIndex,
                    video
                }))
        );
    }

    const handleVideoRedirect = (videoObj: any) => {  
        if (seriesDetails && seriesDetails.length > 0) {
            const seriesId = seriesDetails[0].seriesId
            dispatch(setVideo(videoObj))
            let navigate_ = `/watch?series=${seriesId}&video=${videoObj._id}`
            navigate(navigate_);
        } else {
            alert('no series id found')
        }
    }

    return (
        <>
            <NavBar />
            <div className={`searchVideoCon00 ${searchedVideos.length > 0 ? 'pb-[20px]' : ''} ${addCurrentThemeClassToEle(currentTheme, 'searchVideoCon00')} mt-[40px]`}>
                
            {topSafeComponent}
                <div className="searchVideoCon">
                    {searchedVideos.length === 0 ? (
                        <p className="noSearchVideoCon">
                            {common.statusText.noSearchResults}
                        </p>
                    ) : (
                        <div>
                            {searchedVideos.map((v: any, index: any) => (
                                <div
                                    onClick={() => handleVideoRedirect(v.video)}
                                    className="searchVideoCon01" key={index}>
                                    <img
                                        className="thumbnailUrl"
                                        src={v.video.thumbnailUrl} alt="thumbnailUrl" />
                                    <div>
                                        <p className="title">{v.video.title}</p>
                                        <p className="moduleNumber">{v.sectionIndex + 1}{' '}{common.statusText.module}</p>
                                    </div>
                                </div>
                            ))}
                            <p className="totalReultsText">
                                {searchedVideos.length}{' '}{common.statusText.searchResultsFound}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
